import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy'
import { useEffect, useState } from 'react'
import { Input } from 'antd'
import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { slices } from 'store/slices'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { calculateSectionTotals } from 'helpers/evaluations/calculateSectionTotals'
import {
  Wrapper,
  Title,
  Information,
  MinimumPassingScore,
  Alert,
} from './styled'

const EvaluationScore = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.evaluationScore'
  const data = useAppSelector(slices.questionBank.data)
  const [questionToDisplay, setQuestionToDisplay] = useState(0)
  const [totalScore, setTotalScore] = useState(0)

  useEffect(() => {
    let totalQuestions = 0
    let score = 0

    data.sections.forEach((section) => {
      const sectionResume = calculateSectionTotals(section)
      totalQuestions += sectionResume.totalQuestions
      score += sectionResume.score
    })

    setQuestionToDisplay(totalQuestions)
    setTotalScore(score)
  }, [data])

  const minimumPassingScore =
    typeof data.minimumPassingScore === 'number' ? data.minimumPassingScore : 0

  return (
    <Wrapper>
      <Title>{t(`${translationPrefix}.title`)}</Title>
      <Information>
        <div>
          <div>
            <span>{t(`${translationPrefix}.questionsToDisplay.title`)}</span>
            <div>
              {t(`${translationPrefix}.questionsToDisplay.description`)}
            </div>
          </div>
          <div>
            <FontAwesomeIcon icon={faList} />
            <span>{questionToDisplay}</span>
            {t(
              `${translationPrefix}.questionsToDisplay.${
                questionToDisplay > 1 ? 'questions' : 'question'
              }`
            )}
          </div>
        </div>
        <div>
          <div>
            <span>{t(`${translationPrefix}.totalScore.title`)}</span>
            <div>{t(`${translationPrefix}.totalScore.description`)}</div>
          </div>
          <div>
            <FontAwesomeIcon icon={faTrophy} />
            <span>{totalScore}</span>
            {t(
              `${translationPrefix}.totalScore.${
                totalScore > 1 ? 'scores' : 'score'
              }`
            )}
          </div>
        </div>
      </Information>
      {minimumPassingScore > totalScore && (
        <Alert>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <div>
            {t(`${translationPrefix}.minimumPassingScore.alert`)
              .replace('{totalScore}', totalScore.toString())
              .replace(
                '{minimumPassingScore}',
                data.minimumPassingScore.toString()
              )}
          </div>
        </Alert>
      )}
      <MinimumPassingScore>
        <div>
          <span>{t(`${translationPrefix}.minimumPassingScore.title`)}</span>
          <div>{t(`${translationPrefix}.minimumPassingScore.description`)}</div>
        </div>
        <div>
          <div>
            <Input
              type="number"
              min={1}
              max={totalScore}
              value={data.minimumPassingScore}
              onChange={(e) => {
                dispatch(
                  slices.questionBank.setMinimumPassingScore(
                    e.target.value === '' ? '' : Number(e.target.value)
                  )
                )
              }}
            />
            <span>
              {t(
                `${translationPrefix}.minimumPassingScore.${
                  minimumPassingScore > 1 ? 'scores' : 'score'
                }`
              )}
            </span>
          </div>
          <div>
            <FontAwesomeIcon icon={faInfoCircle} />
            <span>{`${Math.round(
              (minimumPassingScore / totalScore) * 100
            )}% `}</span>
            <span>
              {t(`${translationPrefix}.minimumPassingScore.totalScore`)}
            </span>
          </div>
        </div>
      </MinimumPassingScore>
    </Wrapper>
  )
}

export default EvaluationScore
